import React from 'react';
import { Button, Modal, Toast, Alerts } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IStateType } from '../../../../../../store/models/root.interface';

export type DispatchPropsType = {
    onDeleteSenderIds: (reqData: string[], name: string[], callback: (resp: any, flag: boolean) => void) => void;
    onLoadSenderIds: () => void;
    onCloseModal: () => void;
    onDeleteResetSenderIds: () => void;
}

export type MapStatePropsType = {
    modalVisibility: boolean
    Params:any
}

export const SmsSenderIdsDeleteModal: React.FC<MapStatePropsType & DispatchPropsType> = ({ onDeleteSenderIds, onLoadSenderIds, onCloseModal, modalVisibility, onDeleteResetSenderIds, Params }) => {
    const { t } = useTranslation();
    const deleteIds = useSelector(
        (state: IStateType) => state.senderId.smsSenderDeleteIds
    );
    const deleteNames = useSelector(
        (state: IStateType) => state.senderId.smsSenderDeleteNames
    );
    const count = deleteIds.length;
    const component = 'Sender ID(s)';
    
    const handleDeleteCallback = (res: any, success: boolean) => {
        if (success) {
            Toast(res.data.message, "success");
            onLoadSenderIds();
            onDeleteResetSenderIds();
        } else {
            Toast(res?.data?.error?.message, "error");
        }
        onCloseModal()
    }
    const footerBody = () => {
        return (
            <>
                <Button type="tertiary" onClick={() => { onCloseModal() }}>{t('KLR01801')}</Button>
                <Button type="danger" onClick={() => onDeleteSenderIds(deleteIds, deleteNames,handleDeleteCallback)}>{t('KLR01800')}</Button>
            </>
        )
    }

    return (
        <Modal
            visible={modalVisibility}
            title={t('KLR01803')}
            body={<><Alerts type="warning" content={t('KLR01819',{component})}/><div style={{marginTop:"10px"}}>{Params.extraParams?.isMany?t('KLR01817',{count}):t('KLR01818')}</div></>}
            footer={footerBody()}
        />
    );
}

export default SmsSenderIdsDeleteModal;